import kidbotEyes from '../images/kidbot-eyes.jpg';
import kidbotFootball from '../images/kidbot-football.jpg';
import kidbotWin from '../images/kidbot-win.jpg';

import boxes from '../images/boxes.jpg';
import dancingCroppedVideo from '../images/dancing-cropped.mp4';
import dancingCroppedThumbnail from '../images/dancing-cropped.jpg';

function Home() {
  return (
    <section>
      <div className="photos">
          <img src={kidbotEyes} alt="Girl with Decorated Bot" />
          <img src={kidbotFootball} alt="Boy with Decorated Bot" />
          <img src={kidbotWin} alt="Triumphant Assembly of Bot" />
          <div className="photos-wide">
            <img src={boxes} alt="Stacks of Bot Kits" />
          </div>
      </div>

      <div className="mission">
          <p>We're bringing robots to everyone.</p>
      </div>

      <div className="video">
          <video src={dancingCroppedVideo} loop muted autoPlay poster={dancingCroppedThumbnail}>
              <img className="video-placeholder" src={dancingCroppedThumbnail} />
          </video>
      </div>

      <div className="profiles">

        <div className="profile">
            <h2>Brian Mathews</h2>
            <b>Managing Partner/Founder</b>
        </div>

        <div className="profile">
            <h2>Alan Johnson</h2>
            <b>Managing Partner</b>
        </div>

        <div className="profile">
            <h2>Cooper Welch</h2>
            <b>Executive Creative Director</b>
        </div>

      </div>
    </section>
  );
}

export default Home;
